// Lazy load function
const lazyLoad = (file) => () => import(/* webpackChunkName: "[request]" */ `@/views/products/${file}.vue`);

export default [
    {
        path: "/product",
        name: "product-list",
        meta: { requiresAuth: true, applicationFeatureCode: "Product" },
        components: {
            content: lazyLoad('product-list'),
        },
    },


    {
        path: "/product/create",
        name: "product-detail-create",
        meta: { requiresAuth: true, applicationFeatureCode: "Product" },
        components: {
            content: lazyLoad('product-detail'),
        },
    },
    {
        path: "/product/edit/:id",
        name: "product-detail-edit",
        meta: { requiresAuth: true, applicationFeatureCode: "Product" },
        components: {
            content: lazyLoad('product-detail'),
        },
    },
    {
        path: "/product/review/:id",
        name: "product-detail-review",
        meta: { requiresAuth: true, applicationFeatureCode: "Product" },
        components: {
            content: lazyLoad('product-detail'),
        },
    },

    {
        path: "/product-supplier/:id",
        name: "product-supplier",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "ProductSupplier",
        },
        components: {
            content: lazyLoad('product-supplier'),
        },
    },

    {
        path: "/product-supplier/review/:id",
        name: "product-supplier-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "ProductSupplier",
        },
        components: {
            content: lazyLoad('product-supplier'),
        },
    },
    {
        path: "/product-supplier/edit/:id",
        name: "product-supplier-edit",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "ProductSupplier",
        },
        components: {
            content: lazyLoad('product-supplier'),
        },
    },
    {
        path: "/product-supplier/create/:id",
        name: "product-supplier-create",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "ProductSupplier",
        },
        components: {
            content: lazyLoad('product-supplier'),
        },
    },

    {
        path: "/product-cost/:id",
        name: "product-cost",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "ProductCost",
        },
        components: {
            content: lazyLoad('product-cost'),
        },
    },
    {
        path: "/product-cost/review/:id",
        name: "product-cost-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "ProductCost",
        },
        components: {
            content: lazyLoad('product-cost'),
        },
    },
    {
        path: "/product-cost/edit/:id",
        name: "product-cost-edit",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "ProductCost",
        },
        components: {
            content: lazyLoad('product-cost'),
        },
    },

    {
        path: "/product-unit-of-measure/:id",
        name: "product-unit-of-measure",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "ProductUnitOfMeasure",
        },
        components: {
            content: lazyLoad('product-unit-of-measure'),
        },
    },
    {
        path: "/product-unit-of-measure/create/:id",
        name: "product-unit-of-measure-create",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "ProductUnitOfMeasure",
        },
        components: {
            content: lazyLoad('product-unit-of-measure'),
        },
    },
    {
        path: "/product-unit-of-measure/review/:id",
        name: "product-unit-of-measure-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "ProductUnitOfMeasure",
        },
        components: {
            content: lazyLoad('product-unit-of-measure'),
        },
    },
    {
        path: "/product-unit-of-measure/edit/:id",
        name: "product-unit-of-measure-edit",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "ProductUnitOfMeasure",
        },
        components: {
            content: lazyLoad('product-unit-of-measure'),
        },
    },

    {
        path: "/product-location/:id",
        name: "product-location",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "ProductBin",
        },
        components: {
            content: lazyLoad('product-location'),
        },
    },
    {
        path: "/product-location/create/:id",
        name: "product-location-create",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "ProductBin",
        },
        components: {
            content: lazyLoad('product-location'),
        },
    },
    {
        path: "/product-location/review/:id",
        name: "product-location-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "ProductBin",
        },
        components: {
            content: lazyLoad('product-location'),
        },
    },
    {
        path: "/product-location/edit/:id",
        name: "product-location-edit",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "ProductBin",
        },
        components: {
            content: lazyLoad('product-location'),
        },
    },

    {
        path: "/product-dimension/:id",
        name: "product-dimension",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "ProductDimension",
        },
        components: {
            content: lazyLoad('product-dimension'),
        },
    },

    {
        path: "/product-dimension/review/:id",
        name: "product-dimension-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "ProductDimension",
        },
        components: {
            content: lazyLoad('product-dimension'),
        },
    },
    {
        path: "/product-dimension/edit/:id",
        name: "product-dimension-edit",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "ProductDimension",
        },
        components: {
            content: lazyLoad('product-dimension'),
        },
    },

    {
        path: "/product-kit-components/review/:id",
        name: "product-kit-components-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "Product",
        },
        components: {
            content: lazyLoad('product-kit-components'),
        },
    },
    {
        path: "/product-kit-components/edit/:id",
        name: "product-kit-components-edit",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "Product",
        },
        components: {
            content: lazyLoad('product-kit-components'),
        },
    },

    {
        path: "/product-custom-field/edit/:id",
        name: "product-custom-field-edit",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "ProductCustomField",
        },
        components: {
            content: lazyLoad('product-custom-field'),
        },
    },
    {
        path: "/product-custom-field/review/:id",
        name: "product-custom-field-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "ProductCustomField",
        },
        components: {
            content: lazyLoad('product-custom-field'),
        },
    }

]; 